import { TFunction } from "i18next";

export const CLONE_TECH_PREFIX = "_CLONE_";
export const CLONE_DISH_NAME_MAX_LENGTH = 100;
export const CLONE_MENU_NAME_MAX_LENGTH = 50;

const getUiClonePrefix = (t: TFunction) => t("Copy -").trim();

/**
 * - "_CLONE_My menu" → "Copy - My menu"
 * - "My menu" → "My menu"
 */
export const cloneNameToDisplay = (apiName: string | null | undefined, t: TFunction): string => {
    if (!apiName) return "";
    const tech = CLONE_TECH_PREFIX;

    if (!apiName.startsWith(tech)) return apiName;

    const base = apiName.slice(tech.length);
    const uiPrefix = getUiClonePrefix(t);

    return base ? `${uiPrefix} ${base}` : uiPrefix;
};

/**
 * - "Copy - My menu" → "_CLONE_My menu"
 * - "_CLONE_My menu" → "_CLONE_My menu"
 * - "My menu" → "My menu"
 */
export const cloneNameToApi = (uiName: string | null | undefined, t: TFunction): string => {
    if (!uiName) return "";

    const trimmed = uiName.trim();
    if (!trimmed) return "";

    const tech = CLONE_TECH_PREFIX;
    const uiPrefix = getUiClonePrefix(t);
    const uiWithSpace = `${uiPrefix} `;

    if (trimmed.startsWith(tech)) {
        return trimmed;
    }

    if (trimmed.startsWith(uiWithSpace)) {
        const base = trimmed.slice(uiWithSpace.length);
        return tech + base;
    }

    return trimmed;
};

/**
 * Default name value when cloning.
 * Guaranteed that the "Copy -" prefix will only appear once.
 *
 * - клонируем "My menu" → "Copy - My menu"
 * - клонируем "_CLONE_My menu" → "Copy - My menu"
 */
export const buildCloneInitialDisplayName = (apiName: string | null | undefined, t: TFunction): string => {
    if (!apiName) return "";

    const uiPrefix = getUiClonePrefix(t);
    const uiWithSpace = `${uiPrefix} `;
    const displayName = cloneNameToDisplay(apiName, t);

    const base = displayName.startsWith(uiWithSpace) ? displayName.slice(uiWithSpace.length) : displayName;

    return base ? `${uiPrefix} ${base}` : "";
};

export const buildCloneInitialDisplayNameWithLimit = (
    apiName: string | null | undefined,
    t: TFunction,
    maxLength: number
): string => {
    const full = buildCloneInitialDisplayName(apiName, t);
    if (!full) return "";
    return full.length > maxLength ? full.slice(0, maxLength) : full;
};
